<template>
  <div class="page-container">
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item>
        仪表盘
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content"> </el-card>
  </div>
</template>

<script>
import './store';

export default {
  name: 'Dashboard'
};
</script>

<style lang="less" scoped></style>
